import { COGNITO_STATE, selectCognitoState } from 'utils/cognito.util';

const selectIsAuthenticated = (state) => {
  const cognitoState = selectCognitoState(state);

  // returning null as a signal for "have no info at this moment"
  if (cognitoState === COGNITO_STATE.loading) {
    return null;
  }

  return cognitoState === COGNITO_STATE.in;
};

// noinspection JSUnusedGlobalSymbols
export default selectIsAuthenticated;
